import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses.js';
import { retrievingContentMsg, t } from '../../common/i18n/index.js';

import './Loading.scss';

interface LoadingProps {
  big?: boolean;
  large?: boolean;
  medium?: boolean;
  bottomPadding?: 0 | 1 | 2 | 4;
  topPadding?: 0 | 1 | 2 | 4;
  text?: boolean;
}

export const Loading = ({ big, large, medium, bottomPadding = 0, text, topPadding = 4 }: LoadingProps) => (
  <div
    className={`of-loading ${
      text ? '' : dsClass.JUSTIFY_CONTENT_CENTER
    } of-loading--p-t-${topPadding} of-loading--p-b-${bottomPadding}`}
  >
    <CL.LoadingSpinner
      i18n_loadingspinner_ariaText={t.FLKQ(retrievingContentMsg)}
      size={big ? 'xl' : large ? 'l' : medium ? 'm' : 's'}
    />
    {text && (
      <span aria-hidden="true" className={dsClass.PADDING_LEFT_3}>
        {t.FLKQ(retrievingContentMsg)}
      </span>
    )}
  </div>
);
